export default __webpack_public_path__ + "static/media/image_6.f4aa7bcd.jpg";